import { Switch } from '@thanx/uikit/switch'
import { buildTranslate } from 'locales'
import isEmpty from 'lodash/isEmpty'
import { I18n } from 'react-redux-i18n'
import {
  getDiscountedModifiersText,
  getDiscountedProductsText,
} from 'scenes/RedeemManager/helpers'
import { RedeemTypeModifier } from 'scenes/RedeemManager/types'
import ModifierSelect from './ModifierSelect'
import ProductSelect from './ProductSelect'

const t = buildTranslate(
  'redeem_manager.builder.steps.configuration.online_redemption_card'
)

type ModifierRedemptionProps = {
  discountedModifierIds: string[]
  productIds: string[]
  typeModifier: RedeemTypeModifier | null
}

const ModifierRedemption = ({
  discountedModifierIds,
  productIds,
  typeModifier,
}: ModifierRedemptionProps) => {
  const subtype = typeModifier?.subtype
  const noSubTypeOrDiscountModifiers = Boolean(
    subtype === null && !isEmpty(discountedModifierIds)
  )
  const isFreeModifier = subtype?.includes('modifier') ?? false
  const displayModifierSelect =
    subtype !== 'purchase' && (isFreeModifier || noSubTypeOrDiscountModifiers)
  const {
    label: productsLabel,
    fallbackLabel: productsFallbackLabel,
    helpText: productsHelpText,
    fallbackHelpText: productsFallbackHelpText,
  } = getDiscountedProductsText(false, subtype)
  const {
    label: modifiersLabel,
    helpText: modifiersHelpText,
    fallbackHelpText: modifiersFallbackHelpText,
  } = getDiscountedModifiersText(subtype)

  return (
    <Switch
      condition={displayModifierSelect}
      fallback={<p className="grey-70">{t('will_be_able_to_redeem')}</p>}
    >
      <ProductSelect
        label={productsLabel}
        fallbackLabel={productsFallbackLabel}
        helpText={productsHelpText}
        fallbackHelpText={productsFallbackHelpText}
        // This name is somewhat misleading, as it represents the 'discounted_related'
        // attribute for the modifiers
        name="onlineDiscountedProductIds"
        value={productIds}
        validations={{ isRequired: true }}
        validationErrors={{
          isRequired: I18n.t('validations.is_required'),
        }}
      />
      <ModifierSelect
        productIds={productIds}
        label={modifiersLabel}
        helpText={modifiersHelpText}
        fallbackHelpText={modifiersFallbackHelpText}
        name="onlineDiscountedModifierIds"
        value={discountedModifierIds}
        shouldDisplayPopover={!isFreeModifier}
        validations={{ isRequired: true }}
        validationErrors={{
          isRequired: I18n.t('validations.is_required'),
        }}
      />
      <p className="mt-xs body-text-4 grey-70">
        {isFreeModifier
          ? t('will_apply_lowest_free_modifier')
          : t('will_apply_lowest_modifier')}
      </p>
    </Switch>
  )
}

export default ModifierRedemption
